import styled from 'styled-components';

// descendent selector overrides border styles on basecell, basecell borders should be removed when tables are converted
export const StyledRow = styled.div`
  & {
    background: ${({ isSelected }) => (isSelected ? '#ecf6fa' : '#fff')};
    border-top: 1px solid #eaeaea;
    display: table-row;
    width: 100%;
  }

  [data-role='cell'] {
    border: none;
  }
`;

export const StyledSummaryRow = styled(StyledRow)`
  & {
    background: #eaf8fd;
  }
`;
